export class EquipmentCategory {
  categoryId: number;
  categoryName: string;
  featuredYN: string;
  titleFlag: string;

  public static constructFromObjectJson(objectJson: any): EquipmentCategory {
    const equipmentCategory: EquipmentCategory = Object.assign(new EquipmentCategory(), objectJson);
    return equipmentCategory;
  }

  public static constructFromMapEntry(mapEntry: any): EquipmentCategory {
    const equipmentCategory: EquipmentCategory = new EquipmentCategory();
    equipmentCategory.categoryId = mapEntry[0];
    equipmentCategory.categoryName = mapEntry[1];
    return equipmentCategory;
  }

  public static constructEquipmentCategory(categoryId: number, name: string): EquipmentCategory {
    const equipmentCategory: EquipmentCategory = new EquipmentCategory();
    equipmentCategory.categoryId = categoryId;
    equipmentCategory.categoryName = name;
    return equipmentCategory;
  }
}
